<div
  class="form-group"
  [formGroup]="formGroup!"
>
  <a
    class="lg-link"
    href="javascript:void(0)"
    (click)="config?.clickHandler?.($event)"
  >{{ config?.value }}</a>
</div>
